// Generated from ./src/providers/syntax/lexer/FPlusParser.g4 by ANTLR 4.13.2

import { ParseTreeVisitor } from 'antlr4'

import { FunctionScriptContext } from './FPlusParser.js'
import { ExpressionScriptContext } from './FPlusParser.js'
import { TypeParametersContext } from './FPlusParser.js'
import { TypeParameterContext } from './FPlusParser.js'
import { FunctionValueParametersContext } from './FPlusParser.js'
import { FunctionValueParameterContext } from './FPlusParser.js'
import { FunctionValueParametersWithOptionalTypeContext } from './FPlusParser.js'
import { DeconstructuringDeclarationContext } from './FPlusParser.js'
import { VariableDeclarationContext } from './FPlusParser.js'
import { CommaOrSemicolonContext } from './FPlusParser.js'
import { LetDeclarationInitializerContext } from './FPlusParser.js'
import { AssertDeclarationInitializerContext } from './FPlusParser.js'
import { ImportDeclarationInitializerContext } from './FPlusParser.js'
import { AssertInitializerContext } from './FPlusParser.js'
import { ImportInitializerContext } from './FPlusParser.js'
import { LetInitializerContext } from './FPlusParser.js'
import { PropertyDeclarationContext } from './FPlusParser.js'
import { ParameterWithOptionalTypeContext } from './FPlusParser.js'
import { ParameterContext } from './FPlusParser.js'
import { TypeContext } from './FPlusParser.js'
import { TupleTypeContext } from './FPlusParser.js'
import { UserTypeContext } from './FPlusParser.js'
import { FunctionTypeContext } from './FPlusParser.js'
import { FunctionTypeParametersContext } from './FPlusParser.js'
import { ParenthesizedTypeContext } from './FPlusParser.js'
import { ReceiverTypeContext } from './FPlusParser.js'
import { SemiContext } from './FPlusParser.js'
import { ExpressionContext } from './FPlusParser.js'
import { ExpressionWithoutFunctionLiteralContext } from './FPlusParser.js'
import { FunctionDefinitionContext } from './FPlusParser.js'
import { DisjunctionContext } from './FPlusParser.js'
import { ConjunctionContext } from './FPlusParser.js'
import { XorContext } from './FPlusParser.js'
import { EqualityContext } from './FPlusParser.js'
import { ComparisonContext } from './FPlusParser.js'
import { InfixOperationContext } from './FPlusParser.js'
import { InfixOperationEntryContext } from './FPlusParser.js'
import { ElvisExpressionContext } from './FPlusParser.js'
import { InfixFunctionCallContext } from './FPlusParser.js'
import { AdditiveExpressionContext } from './FPlusParser.js'
import { MultiplicativeExpressionContext } from './FPlusParser.js'
import { PowerExpressionContext } from './FPlusParser.js'
import { AsExpressionContext } from './FPlusParser.js'
import { PrefixUnaryExpressionContext } from './FPlusParser.js'
import { UnaryPrefixContext } from './FPlusParser.js'
import { PostfixUnaryExpressionContext } from './FPlusParser.js'
import { PostfixUnarySuffixContext } from './FPlusParser.js'
import { IsDefinedSuffixContext } from './FPlusParser.js'
import { IndexingSuffixContext } from './FPlusParser.js'
import { NotUndefinedAssertionContext } from './FPlusParser.js'
import { PercentOperatorContext } from './FPlusParser.js'
import { NavigationSuffixContext } from './FPlusParser.js'
import { CallSuffixContext } from './FPlusParser.js'
import { VarianceContext } from './FPlusParser.js'
import { VarianceTypeContext } from './FPlusParser.js'
import { TypeArgumentsContext } from './FPlusParser.js'
import { TypeArgumentsWithoutVarianceContext } from './FPlusParser.js'
import { ValueArgumentsContext } from './FPlusParser.js'
import { ValueArgumentContext } from './FPlusParser.js'
import { PrimaryExpressionContext } from './FPlusParser.js'
import { ParenthesizedExpressionContext } from './FPlusParser.js'
import { MapPairContext } from './FPlusParser.js'
import { MapLiteralContext } from './FPlusParser.js'
import { SetLiteralContext } from './FPlusParser.js'
import { ListLiteralContext } from './FPlusParser.js'
import { RangeLiteralContext } from './FPlusParser.js'
import { TupleLiteralContext } from './FPlusParser.js'
import { ImplicitVariableLiteralContext } from './FPlusParser.js'
import { ImplicitNavigationContext } from './FPlusParser.js'
import { LiteralConstantContext } from './FPlusParser.js'
import { StringLiteralContext } from './FPlusParser.js'
import { SingleQuoteStringLiteralContext } from './FPlusParser.js'
import { SingleLineStringLiteralEntryContext } from './FPlusParser.js'
import { SingleLineStringContentContext } from './FPlusParser.js'
import { SingleLineStringExpressionContext } from './FPlusParser.js'
import { LineStringLiteralContext } from './FPlusParser.js'
import { LineStringLiteralEntryContext } from './FPlusParser.js'
import { LineStringContentContext } from './FPlusParser.js'
import { LineStringExpressionContext } from './FPlusParser.js'
import { MultiLineStringLiteralContext } from './FPlusParser.js'
import { MultiLineStringLiteralEntryContext } from './FPlusParser.js'
import { MultiLineStringContentContext } from './FPlusParser.js'
import { MultiLineStringExpressionContext } from './FPlusParser.js'
import { LambdaLiteralContext } from './FPlusParser.js'
import { AnonymousFunctionContext } from './FPlusParser.js'
import { FunctionLiteralContext } from './FPlusParser.js'
import { IfExpressionContext } from './FPlusParser.js'
import { WhenSubjectContext } from './FPlusParser.js'
import { WhenExpressionContext } from './FPlusParser.js'
import { WhenArrowBodyContext } from './FPlusParser.js'
import { WhenArrowEntryContext } from './FPlusParser.js'
import { WhenColonBodyContext } from './FPlusParser.js'
import { WhenColonEntryContext } from './FPlusParser.js'
import { WhenConditionContext } from './FPlusParser.js'
import { TupleTestEntryContext } from './FPlusParser.js'
import { TupleTestContext } from './FPlusParser.js'
import { RangeTestContext } from './FPlusParser.js'
import { TypeTestContext } from './FPlusParser.js'
import { EqualityOperatorContext } from './FPlusParser.js'
import { ComparisonOperatorContext } from './FPlusParser.js'
import { InOperatorContext } from './FPlusParser.js'
import { IsOperatorContext } from './FPlusParser.js'
import { AdditiveOperatorContext } from './FPlusParser.js'
import { MultiplicativeOperatorContext } from './FPlusParser.js'
import { PowerOperatorContext } from './FPlusParser.js'
import { PrefixUnaryOperatorContext } from './FPlusParser.js'
import { ExclContext } from './FPlusParser.js'
import { SimpleIdentifierContext } from './FPlusParser.js'
import { NavigationIdentifierContext } from './FPlusParser.js'

/**
 * This interface defines a complete generic visitor for a parse tree produced
 * by `FPlusParser`.
 *
 * @param <Result> The return type of the visit operation. Use `void` for
 * operations with no return type.
 */
export default class FPlusParserVisitor<
  Result,
> extends ParseTreeVisitor<Result> {
  /**
   * Visit a parse tree produced by `FPlusParser.functionScript`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionScript?: (ctx: FunctionScriptContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.expressionScript`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitExpressionScript?: (ctx: ExpressionScriptContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.typeParameters`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTypeParameters?: (ctx: TypeParametersContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.typeParameter`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTypeParameter?: (ctx: TypeParameterContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionValueParameters`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionValueParameters?: (ctx: FunctionValueParametersContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionValueParameter`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionValueParameter?: (ctx: FunctionValueParameterContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionValueParametersWithOptionalType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionValueParametersWithOptionalType?: (
    ctx: FunctionValueParametersWithOptionalTypeContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.deconstructuringDeclaration`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitDeconstructuringDeclaration?: (
    ctx: DeconstructuringDeclarationContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.variableDeclaration`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitVariableDeclaration?: (ctx: VariableDeclarationContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.commaOrSemicolon`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitCommaOrSemicolon?: (ctx: CommaOrSemicolonContext) => Result
  /**
   * Visit a parse tree produced by the `letDeclarationInitializer`
   * labeled alternative in `FPlusParser.propertyInitializer`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLetDeclarationInitializer?: (
    ctx: LetDeclarationInitializerContext,
  ) => Result
  /**
   * Visit a parse tree produced by the `assertDeclarationInitializer`
   * labeled alternative in `FPlusParser.propertyInitializer`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitAssertDeclarationInitializer?: (
    ctx: AssertDeclarationInitializerContext,
  ) => Result
  /**
   * Visit a parse tree produced by the `importDeclarationInitializer`
   * labeled alternative in `FPlusParser.propertyInitializer`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitImportDeclarationInitializer?: (
    ctx: ImportDeclarationInitializerContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.assertInitializer`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitAssertInitializer?: (ctx: AssertInitializerContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.importInitializer`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitImportInitializer?: (ctx: ImportInitializerContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.letInitializer`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLetInitializer?: (ctx: LetInitializerContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.propertyDeclaration`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPropertyDeclaration?: (ctx: PropertyDeclarationContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.parameterWithOptionalType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitParameterWithOptionalType?: (
    ctx: ParameterWithOptionalTypeContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.parameter`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitParameter?: (ctx: ParameterContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.type`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitType?: (ctx: TypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.tupleType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTupleType?: (ctx: TupleTypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.userType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitUserType?: (ctx: UserTypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionType?: (ctx: FunctionTypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionTypeParameters`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionTypeParameters?: (ctx: FunctionTypeParametersContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.parenthesizedType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitParenthesizedType?: (ctx: ParenthesizedTypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.receiverType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitReceiverType?: (ctx: ReceiverTypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.semi`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSemi?: (ctx: SemiContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.expression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitExpression?: (ctx: ExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.expressionWithoutFunctionLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitExpressionWithoutFunctionLiteral?: (
    ctx: ExpressionWithoutFunctionLiteralContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionDefinition`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionDefinition?: (ctx: FunctionDefinitionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.disjunction`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitDisjunction?: (ctx: DisjunctionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.conjunction`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitConjunction?: (ctx: ConjunctionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.xor`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitXor?: (ctx: XorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.equality`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitEquality?: (ctx: EqualityContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.comparison`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitComparison?: (ctx: ComparisonContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.infixOperation`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitInfixOperation?: (ctx: InfixOperationContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.infixOperationEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitInfixOperationEntry?: (ctx: InfixOperationEntryContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.elvisExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitElvisExpression?: (ctx: ElvisExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.infixFunctionCall`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitInfixFunctionCall?: (ctx: InfixFunctionCallContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.additiveExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitAdditiveExpression?: (ctx: AdditiveExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.multiplicativeExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMultiplicativeExpression?: (
    ctx: MultiplicativeExpressionContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.powerExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPowerExpression?: (ctx: PowerExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.asExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitAsExpression?: (ctx: AsExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.prefixUnaryExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPrefixUnaryExpression?: (ctx: PrefixUnaryExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.unaryPrefix`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitUnaryPrefix?: (ctx: UnaryPrefixContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.postfixUnaryExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPostfixUnaryExpression?: (ctx: PostfixUnaryExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.postfixUnarySuffix`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPostfixUnarySuffix?: (ctx: PostfixUnarySuffixContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.isDefinedSuffix`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitIsDefinedSuffix?: (ctx: IsDefinedSuffixContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.indexingSuffix`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitIndexingSuffix?: (ctx: IndexingSuffixContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.notUndefinedAssertion`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitNotUndefinedAssertion?: (ctx: NotUndefinedAssertionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.percentOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPercentOperator?: (ctx: PercentOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.navigationSuffix`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitNavigationSuffix?: (ctx: NavigationSuffixContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.callSuffix`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitCallSuffix?: (ctx: CallSuffixContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.variance`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitVariance?: (ctx: VarianceContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.varianceType`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitVarianceType?: (ctx: VarianceTypeContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.typeArguments`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTypeArguments?: (ctx: TypeArgumentsContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.typeArgumentsWithoutVariance`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTypeArgumentsWithoutVariance?: (
    ctx: TypeArgumentsWithoutVarianceContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.valueArguments`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitValueArguments?: (ctx: ValueArgumentsContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.valueArgument`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitValueArgument?: (ctx: ValueArgumentContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.primaryExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPrimaryExpression?: (ctx: PrimaryExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.parenthesizedExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitParenthesizedExpression?: (ctx: ParenthesizedExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.mapPair`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMapPair?: (ctx: MapPairContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.mapLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMapLiteral?: (ctx: MapLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.setLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSetLiteral?: (ctx: SetLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.listLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitListLiteral?: (ctx: ListLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.rangeLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitRangeLiteral?: (ctx: RangeLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.tupleLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTupleLiteral?: (ctx: TupleLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.implicitVariableLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitImplicitVariableLiteral?: (ctx: ImplicitVariableLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.implicitNavigation`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitImplicitNavigation?: (ctx: ImplicitNavigationContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.literalConstant`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLiteralConstant?: (ctx: LiteralConstantContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.stringLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitStringLiteral?: (ctx: StringLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.singleQuoteStringLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSingleQuoteStringLiteral?: (
    ctx: SingleQuoteStringLiteralContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.singleLineStringLiteralEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSingleLineStringLiteralEntry?: (
    ctx: SingleLineStringLiteralEntryContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.singleLineStringContent`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSingleLineStringContent?: (ctx: SingleLineStringContentContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.singleLineStringExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSingleLineStringExpression?: (
    ctx: SingleLineStringExpressionContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.lineStringLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLineStringLiteral?: (ctx: LineStringLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.lineStringLiteralEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLineStringLiteralEntry?: (ctx: LineStringLiteralEntryContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.lineStringContent`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLineStringContent?: (ctx: LineStringContentContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.lineStringExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLineStringExpression?: (ctx: LineStringExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.multiLineStringLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMultiLineStringLiteral?: (ctx: MultiLineStringLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.multiLineStringLiteralEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMultiLineStringLiteralEntry?: (
    ctx: MultiLineStringLiteralEntryContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.multiLineStringContent`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMultiLineStringContent?: (ctx: MultiLineStringContentContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.multiLineStringExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMultiLineStringExpression?: (
    ctx: MultiLineStringExpressionContext,
  ) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.lambdaLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitLambdaLiteral?: (ctx: LambdaLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.anonymousFunction`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitAnonymousFunction?: (ctx: AnonymousFunctionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.functionLiteral`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitFunctionLiteral?: (ctx: FunctionLiteralContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.ifExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitIfExpression?: (ctx: IfExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenSubject`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenSubject?: (ctx: WhenSubjectContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenExpression`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenExpression?: (ctx: WhenExpressionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenArrowBody`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenArrowBody?: (ctx: WhenArrowBodyContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenArrowEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenArrowEntry?: (ctx: WhenArrowEntryContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenColonBody`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenColonBody?: (ctx: WhenColonBodyContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenColonEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenColonEntry?: (ctx: WhenColonEntryContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.whenCondition`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitWhenCondition?: (ctx: WhenConditionContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.tupleTestEntry`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTupleTestEntry?: (ctx: TupleTestEntryContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.tupleTest`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTupleTest?: (ctx: TupleTestContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.rangeTest`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitRangeTest?: (ctx: RangeTestContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.typeTest`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitTypeTest?: (ctx: TypeTestContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.equalityOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitEqualityOperator?: (ctx: EqualityOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.comparisonOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitComparisonOperator?: (ctx: ComparisonOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.inOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitInOperator?: (ctx: InOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.isOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitIsOperator?: (ctx: IsOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.additiveOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitAdditiveOperator?: (ctx: AdditiveOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.multiplicativeOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitMultiplicativeOperator?: (ctx: MultiplicativeOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.powerOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPowerOperator?: (ctx: PowerOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.prefixUnaryOperator`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitPrefixUnaryOperator?: (ctx: PrefixUnaryOperatorContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.excl`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitExcl?: (ctx: ExclContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.simpleIdentifier`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitSimpleIdentifier?: (ctx: SimpleIdentifierContext) => Result
  /**
   * Visit a parse tree produced by `FPlusParser.navigationIdentifier`.
   * @param ctx the parse tree
   * @return the visitor result
   */
  visitNavigationIdentifier?: (ctx: NavigationIdentifierContext) => Result
}
